import i18n from './i18n';

let routes = {};

i18n.on('initialized', () => {
  routes = {
    en: {
      landing: '/',

      courses: '/' + i18n.t('local:view.courses.manage.slug', {lng: 'en'}),

      coursesManage: '/' + i18n.t('local:view.courses.manage.slug', {lng: 'en'}),
      coursesCreate:  i18n.t('local:view.courses.create.slug', {lng: 'en'}),

      coursesDuplicate:  i18n.t('local:view.courses.duplicate.slug', {lng: 'en'})+'/:course',
      coursesEdit:   i18n.t('local:view.courses.edit.slug', {lng: 'en'}) +'/:course',
      coursesUpdateByGroup:  i18n.t('local:view.courses.massUpdate.coursesUpdateByGroup.slug', {lng: 'en'})+'/:courseGroup',
      coursesUpdateBySelected:  i18n.t('local:view.courses.massUpdate.coursesUpdateBySelected.slug', {lng: 'en'}),
      coursesTranslateManage: '/' + i18n.t('local:view.courses.translateManage.slug', {lng: 'en'}) ,
      coursesTranslateAmended:    '/amended/:course',
      coursesTranslateDraft:  '/draft/:course',

      providers: '/' + i18n.t('local:view.providers.manage.slug', {lng: 'en'}),
      translations: '/' + i18n.t('local:view.translations.landing.slug', {lng: 'en'}),
      translationsLanding: '/' + i18n.t('local:view.translations.landing.slug', {lng: 'en'}),
      manageCourseGroups: '/course-groups',

      venuesManage: '/' + i18n.t('local:view.venues.manage.slug', {lng: 'en'}),
      venuesCreate:  i18n.t('local:view.venues.create.slug', {lng: 'en'}),
      venuesEdit:  i18n.t('local:view.venues.edit.slug', {lng: 'en'}) +'/:venue',
      venuesTranslateManage:  '/' + i18n.t('local:view.venues.translateManage.slug', {lng: 'en'}) ,
      venuesTranslateAmended:  '/amended/:venue',
      venuesTranslateDraft:   '/draft/:venue',

      contactsManage: '/' + i18n.t('local:view.contacts.manage.slug', {lng: 'en'}),
      contactsCreate:   i18n.t('local:view.contacts.create.slug', {lng: 'en'}),
      contactsEdit:   i18n.t('local:view.contacts.edit.slug', {lng: 'en'}) +'/:contact',

      courseGroupsManage: '/' + i18n.t('local:view.courseGroups.manage.slug', {lng: 'en'}),
      courseGroupsCreate:   i18n.t('local:view.courseGroups.create.slug', {lng: 'en'}),
      courseGroupsEdit:   i18n.t('local:view.courseGroups.edit.slug', {lng: 'en'}) +'/:courseGroup',

    },
    cy: {
      landing: '/',

      courses: '/' + i18n.t('local:view.courses.manage.slug', {lng: 'cy'}),

      coursesManage: '/' + i18n.t('local:view.courses.manage.slug', {lng: 'cy'}),
      coursesCreate: i18n.t('local:view.courses.create.slug', {lng: 'cy'}),
      coursesDuplicate:  i18n.t('local:view.courses.duplicate.slug', {lng: 'cy'})+'/:course',
      coursesEdit:   i18n.t('local:view.courses.edit.slug', {lng: 'cy'}) +'/:course',
      coursesUpdateByGroup:  i18n.t('local:view.courses.massUpdate.coursesUpdateByGroup.slug', {lng: 'cy'})+'/:courseGroup',
      coursesUpdateBySelected:  i18n.t('local:view.courses.massUpdate.coursesUpdateBySelected.slug', {lng: 'cy'}),
      coursesTranslateManage: '/' + i18n.t('local:view.courses.translateManage.slug', {lng: 'cy'}) ,
      coursesTranslateAmended: '/amended/:course',
      coursesTranslateDraft:  '/drafft/:course',

      providers: '/' + i18n.t('local:view.providers.manage.slug', {lng: 'cy'}),
      translations: '/' + i18n.t('local:view.translations.landing.slug', {lng: 'cy'}),
      translationsLanding: '/' + i18n.t('local:view.translations.landing.slug', {lng: 'cy'}),
      manageCourseGroups: '/course-groups',

      venuesManage: '/' + i18n.t('local:view.venues.manage.slug', {lng: 'cy'}),
      venuesCreate:  i18n.t('local:view.venues.create.slug', {lng: 'cy'}),
      venuesEdit:  i18n.t('local:view.venues.edit.slug', {lng: 'cy'}) +'/:venue',


      venuesTranslateManage:  '/' + i18n.t('local:view.venues.translateManage.slug', {lng: 'cy'}) ,
      venuesTranslateAmended:  '/amended/:venue',
      venuesTranslateDraft:  '/drafft/:venue',

      contactsManage: '/' + i18n.t('local:view.contacts.manage.slug', {lng: 'cy'}),
      contactsCreate:  i18n.t('local:view.contacts.create.slug', {lng: 'cy'}),
      contactsEdit:   i18n.t('local:view.contacts.edit.slug', {lng: 'cy'}) +'/:contact',

      courseGroupsManage: '/' + i18n.t('local:view.courseGroups.manage.slug', {lng: 'cy'}),
      courseGroupsCreate:  i18n.t('local:view.courseGroups.create.slug', {lng: 'cy'}),
      courseGroupsEdit:   i18n.t('local:view.courseGroups.edit.slug', {lng: 'cy'}) +'/:courseGroup',
    }
  }
});

export function route(name, parameters = null, language = i18n.language) {
  if (parameters) {
    return routes[language][name].split('/').map(fragment => {
      return fragment.startsWith(':') ? parameters[fragment.substr(1)] : fragment;
    }).join('/');
  }

  return routes[language][name];
}
